import settings from "@settings";

export const inlineContentContainer = settings.mq({
    width: ['100%', '100%', 'auto'],
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: 'auto',
    padding: [20, 30, 50],
    boxSizing: 'border-box',
    backgroundColor: settings.colors.light,
    color: settings.colors.dark,
})

export const inlineContent = settings.mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: ['center', 'center', 'flex-start'],
    gap: settings.sizes.medium,
    'p': {
        textAlign: ['center', 'center', 'left'],
    }
})